var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_224",
    "data-name": "Group 224",
    transform: "translate(-328.8 -527)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 68,
    height: 68,
    transform: "translate(328.8 527)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-location-on",
    "data-name": "Icon material-location-on",
    d: "M31.3,3A23.783,23.783,0,0,0,7.5,26.8C7.5,44.65,31.3,71,31.3,71S55.1,44.65,55.1,26.8A23.783,23.783,0,0,0,31.3,3Zm0,32.3a8.5,8.5,0,1,1,8.5-8.5A8.5,8.5,0,0,1,31.3,35.3Z",
    transform: "translate(331.5 524)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationLogo);
export default __webpack_public_path__ + "static/media/locationLogo.f041cdb64fb0d887ac1939bb0b63b233.svg";
export { ForwardRef as ReactComponent };